import { Button } from 'primereact/button'
import React from 'react'
import { LuxButtonProps } from '../../models/util'
import LuxIcon from '../icons/LuxIcon'
import './buttons.scss'

const LuxButton = (props: LuxButtonProps) => {
    const {
        variant, // rounded, raised, primary, secondary, text, outlined
        color,
        disabled,
        icon,
        iconPos,
        text,
        badge,
        onClick,
        loading,
        classes,
        style,
        tooltip,
        tooltipPosition,
        onMouseEnter,
        onMouseLeave,
        activeDot,
        notificationsCount,
    } = props

    const renderIcon = (icon) => {
        return typeof icon == 'string' ? `pi pi-${icon}` : icon
    }

    return (
        <Button
            style={style}
            className={`wardrobe-button ${
                variant?.length
                    ? variant.map((v) => `p-button-${v}`).join(' ')
                    : ''
            } ${classes ? classes : ''}`}
            color={color ? color : 'primary'}
            disabled={disabled}
            label={text}
            icon={icon ? renderIcon(icon) : undefined}
            iconPos={iconPos}
            badge={badge}
            loading={loading}
            onClick={onClick}
            tooltip={tooltip}
            tooltipOptions={{ position: tooltipPosition }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}>
            {activeDot && <div className="activeDot"></div>}
            {notificationsCount ? (
                <div className="notifications-count">{notificationsCount}</div>
            ) : null}
        </Button>
    )
}

export default LuxButton
